// extracted by mini-css-extract-plugin
export var bubble = "_x-0";
export var container = "_x-f";
export var contrastBorder = "_x-g";
export var greyOut = "_x-2";
export var initialsColor0 = "_x-3";
export var initialsColor1 = "_x-4";
export var initialsColor10 = "_x-d";
export var initialsColor11 = "_x-e";
export var initialsColor2 = "_x-5";
export var initialsColor3 = "_x-6";
export var initialsColor4 = "_x-7";
export var initialsColor5 = "_x-8";
export var initialsColor6 = "_x-9";
export var initialsColor7 = "_x-a";
export var initialsColor8 = "_x-b";
export var initialsColor9 = "_x-c";
export var initialsWrapper = "_x-1";
export var large = "_x-l";
export var medium = "_x-k";
export var mediumSmall = "_x-j";
export var mediumSmallMedium = "_x-o";
export var micro = "_x-h";
export var small = "_x-i";
export var tiny = "_x-n";
export var xTiny = "_x-m";